// eslint-disable-next-line import/no-cycle
import { reloadPageUtils } from './index-utils';

export const reloadPage = () => reloadPageUtils();
